import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {MyAnimatedTypo,MyAnimatedTypo2} from "./Moving";

function Intestazione_Logo() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="intestazione-content">
        <Row>
            <div className="home-textMove"> 
                {/*<Type />*/}
                <MyAnimatedTypo />
            </div>
        </Row>  
        <Row>
            <div className="home-textMove2">
            <MyAnimatedTypo2
                textvalue="Amministrazione condominiale chiara, efficace e professionale al vostro servizio."
            />
            </div>
        </Row> 
        </Container>
      </Container>
    </section>
  )
}

export default Intestazione_Logo   
   
   
